import { useFeatureFlag } from '@/feature-flags/hooks/use-feature-flag.hook';

export function useIsFlexSwitchToWhatsappCity(ibgeCode?: string): boolean {
  const { value: cities } = useFeatureFlag('switchFlexToWhatsappCities');

  return ibgeCode ? cities.includes(ibgeCode) : false;
}
